import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSend: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="send, email, paper-plane, arrow"><path d="M20.9551 5.83601C21.4524 4.13074 19.8703 2.54864 18.1651 3.04601L2.49118 7.61756C0.248252 8.27174 0.365216 11.4881 2.64974 11.9776L9.89474 13.5301C10.1835 13.592 10.4091 13.8176 10.4709 14.1063L12.0234 21.3513C12.513 23.6358 15.7293 23.7528 16.3835 21.5099L20.9551 5.83601Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSend;
